import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {uploadWebsiteActions} from "./uploadWebsiteSlice";
import {uploadWebsiteApi} from "~/api";

function* fetchDemoList(action) {
	try {
		const response = yield call(uploadWebsiteApi.gets, action.payload);
		yield put(uploadWebsiteActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch uploadWebsite list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(uploadWebsiteActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(uploadWebsiteActions.setFilter(action.payload));
}

export default function* uploadWebsiteSaga() {
	yield takeLatest(uploadWebsiteActions.fetchData.type, fetchDemoList);
	yield debounce(500, uploadWebsiteActions.setFilterWithDebounce.type, handleSearchDebounce)
}